import  { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  ArcElement
);

const IncidentTrend = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/healthAndSafetyJson`
        );
        

        const rawData = response.data.data.Data;
     
        const filteredData = rawData.filter(item => typeof item["__EMPTY"] === "number");

        // Count occurrences of each type of injury consequence
        const injuryCounts = filteredData.reduce((acc, item) => {
          const consequence = item["__EMPTY_6"];
          acc[consequence] = (acc[consequence] || 0) + 1;
          return acc;
        }, {});

        const labels = Object.keys(injuryCounts);
        const data = Object.values(injuryCounts);

        setChartData({
          labels,
          datasets: [
            {
              label: 'Proportion of Injury Consequences',
              data: data,
              backgroundColor: [
                'rgba(255, 99, 132, 0.6)',
                'rgba(54, 162, 235, 0.6)',
                'rgba(255, 206, 86, 0.6)',
                'rgba(75, 192, 192, 0.6)',
                'rgba(153, 102, 255, 0.6)',
                'rgba(255, 159, 64, 0.6)'
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
              ],
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: 'top',
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            }
          }
        }
      }
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Proportion of Injury Consequences
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Pie
              data={chartData}
              options={options}
            />
          </div>
        </Container>
      </div>
    );
  }
};

export default IncidentTrend;
